<!--
 * @Descripttion: 按钮组件
 * @Author: zenghua.wang
 * @Date: 2021-12-28 10:49:49
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-06 17:35:29
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
    v-if="showDevice"
  >
    <button
      v-for="(item,index) in option.column"
      :key="index"
      type="button"
      :disabled="item.disabled"
      :class="setClass('item',{disabled: item.disabled})"
      :style="styleButton(item)"
      @click="setLink(item.url)"
    >{{item.text}}</button>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import { component } from '@/dragComponents/model/default.js'
import {
  isEmpty,
  setPx,
  setRowByRoute,
  getTextByAnalysis,
  getQueryArrByParams
} from '@/dragComponents/utils'

export default {
  name: 'drag-button',
  mixins: [bem],
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    width: {
      type: [Number, String],
      default: 100
    },
    height: {
      type: [Number, String],
      default: 100
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    showDevice() {
      // 设计
      if (!this.disabled) {
        return true
      }
      // 两端显示
      if (isEmpty(this.option?.device)) {
        return true
      } else {
        // 设备显示
        return this.option?.device === this.device
      }
    },
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width: this.width,
          height: this.height,
          padding: design.padding,
          textAlign: this.option.align
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleButton() {
      return (item) => {
        return Object.assign(
          (() => {
            if (item.round) {
              return {
                borderRadius: '999px'
              }
            }
            return {}
          })(),
          (() => {
            if (item.plain) {
              return {
                border: `1px solid ${item.backgroundColor}`,
                color: '#666',
                backgroundColor: '#fff'
              }
            }
            return {
              color: item.color,
              backgroundColor: item.backgroundColor
            }
          })(),
          {
            fontSize: setPx(item.fontSize)
          }
        )
      }
    }
  },
  methods: {
    setLink(link) {
      let params = getQueryArrByParams(this.$route.query)
      let row = setRowByRoute(params)
      let url = getTextByAnalysis(link, row)
      if (isEmpty(url)) return
      if (url.includes('http')) {
        window.open(url, '_blank')
      } else {
        this.$router.push(url)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.drag-button {
  overflow: hidden;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  &-item {
    display: inline-block;
    padding: 8px 20px;
    margin-left: 10px;
    text-align: center;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    white-space: nowrap;
    font-size: 14px;
    cursor: pointer;
    -webkit-appearance: none;
    outline: none;
    transition: 0.1s;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;

    &__disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
